/* eslint-disable */
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';

// Import Layout components
import PublicLayout from './layouts/PublicLayout'
import PrivateLayout from './layouts/PrivateLayout';

// Import your pages
import Home from './pages/Home';
import AllProducts from './pages/AllProducts';
import CategoryPage from './pages/CategoryPage';
import WishlistPage from './pages/Wishlist';
import ProductDetails from './pages/ProductDetails';
import Cart from './pages/Cart';
import SearchResults from './components/SearchResults';
import MyProfile from './components/Personal/MyProfile';
import MyAddress from './components/Address/MyAddress';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Checkout from './pages/Checkout';
import ProductListing from './components/Cancel/ProductListing';
import ThankYouPage from './pages/ThankYouPage';
import categoriesData from './jsons/categories.json'
import Art from './pages/categories/Art';
import Law from './pages/categories/Law';
import Business from './pages/categories/Business';
import Medical from './pages/categories/Medical';
import Science from './pages/categories/Science';
import Computers from './pages/categories/Computers';
import Education from './pages/categories/Education';
import SocialScience from './pages/categories/Reference';
import Reference from './pages/categories/Reference';
import Nature from './pages/categories/Nature';
import Technology from './pages/categories/Technology';
import Misc from './pages/categories/Misc';
import HouseHome from './pages/categories/HouseHome';
import Engineering from './pages/categories/Engineering';
import Mathematics from './pages/categories/Mathematics';
import LifeSciences from './pages/categories/LifeSciences';
import Dentistry from './pages/categories/Dentistry';
import BestSelling from './pages/categories/BestSelling';
import Feature from './pages/categories/Feature';
import NewArrival from './pages/categories/NewArrival';
import PopularBooks from './pages/categories/PopularBooks';


const generateRoutes = (data) => {
  const routes = [];

  data.forEach((category) => {
    routes.push(
      <Route key={category.id} path={category.link} element={<PrivateLayout><AllProducts /></PrivateLayout> } />
    );
    category.subcategories.forEach((subcategory, index) => {
      routes.push(
        <Route key={`${category.id}-${index}`} path={subcategory.link} element={<PrivateLayout><AllProducts /></PrivateLayout>} />
      );
    });
  });

  return routes;
};


function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes (without header and footer) */}
            <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
            <Route
              path="/register"
              element={<PublicLayout><Register /></PublicLayout>}
            />

            {/* Private Routes (with header and footer) */}
            <Route
              path="/"
              element={
                <PrivateLayout>
                  <Home />
                </PrivateLayout>
              }
            />
            <Route
              path="/all-products"
              element={
                <PrivateLayout>
                  <AllProducts />
                </PrivateLayout>
              }
            />
            <Route
              path="/:category"
              element={
                <PrivateLayout>
                  <CategoryPage />
                </PrivateLayout>
              }
            />
            <Route
              path="/wishlist"
              element={
                <PrivateLayout>
                  <WishlistPage />
                </PrivateLayout>
              }
            />
            <Route
              path="/products/:productId"
              element={
                <PrivateLayout>
                  <ProductDetails />
                </PrivateLayout>
              }
            />
            <Route
              path="/cart"
              element={
                <PrivateLayout>
                  <Cart />
                </PrivateLayout>
              }
            />
            <Route
              path="/search"
              element={
                <PrivateLayout>
                  <SearchResults />
                </PrivateLayout>
              }
            />
            <Route
              path="/myprofile"
              element={
                <PrivateLayout>
                  <MyProfile />
                </PrivateLayout>
              }
            />
            <Route
              path="/myaddress"
              element={
                <PrivateLayout>
                  <MyAddress />
                </PrivateLayout>
              }
            />
            <Route
              path="/checkout"
              element={
                <PrivateLayout>
                  <Checkout />
                </PrivateLayout>
              }
            />
            <Route
              path="/productlisting"
              element={
                <PrivateLayout>
                  <ProductListing />
                </PrivateLayout>
              }
            />
            <Route
              path="/thank-you"
              element={
                <PrivateLayout>
                  <ThankYouPage />
                </PrivateLayout>
              }
            />
            <Route
              path="/art"
              element={
                <PrivateLayout>
                  <Art />
                </PrivateLayout>
              }
            />
            <Route
              path="/law"
              element={
                <PrivateLayout>
                  <Law />
                </PrivateLayout>
              }
            />
            <Route
              path="/business"
              element={
                <PrivateLayout>
                  <Business />
                </PrivateLayout>
              }
            />
            <Route
              path="/medical"
              element={
                <PrivateLayout>
                  <Medical />
                </PrivateLayout>
              }
            />
            <Route
              path="/science"
              element={
                <PrivateLayout>
                  <Science />
                </PrivateLayout>
              }
            />
            <Route
              path="/computers"
              element={
                <PrivateLayout>
                  <Computers />
                </PrivateLayout>
              }
            />
            <Route
              path="/education"
              element={
                <PrivateLayout>
                  <Education />
                </PrivateLayout>
              }
            />
            <Route
              path="/reference"
              element={
                <PrivateLayout>
                  <Reference />
                </PrivateLayout>
              }
            />
            <Route
              path="/nature"
              element={
                <PrivateLayout>
                  <Nature />
                </PrivateLayout>
              }
            />
            <Route
              path="/misc"
              element={
                <PrivateLayout>
                  <Misc />
                </PrivateLayout>
              }
            />
            <Route
              path="/technology"
              element={
                <PrivateLayout>
                  <Technology />
                </PrivateLayout>
              }
            />
            <Route
              path="/dentistry"
              element={
                <PrivateLayout>
                  <Dentistry />
                </PrivateLayout>
              }
            />
            <Route
              path="/life-sciences"
              element={
                <PrivateLayout>
                  <LifeSciences />
                </PrivateLayout>
              }
            />
            <Route
              path="/mathematics"
              element={
                <PrivateLayout>
                  <Mathematics />
                </PrivateLayout>
              }
            />
            <Route
              path="/engineering"
              element={
                <PrivateLayout>
                  <Engineering />
                </PrivateLayout>
              }
            />
            <Route
              path="/house&home"
              element={
                <PrivateLayout>
                  <HouseHome />
                </PrivateLayout>
              }
            />
            <Route
              path="/bestselling"
              element={
                <PrivateLayout>
                  <BestSelling />
                </PrivateLayout>
              }
            />
            <Route
              path="/featuredproducts"
              element={
                <PrivateLayout>
                  <Feature />
                </PrivateLayout>
              }
            />
            <Route
              path="/newarrival"
              element={
                <PrivateLayout>
                  <NewArrival />
                </PrivateLayout>
              }
            />
            <Route
              path="/popularbooks"
              element={
                <PrivateLayout>
                  <PopularBooks />
                </PrivateLayout>
              }
            />
            <Route
              path="/business-economics"
              element={
                <PrivateLayout>
                  <Business />
                </PrivateLayout>
              }
            />
            {/* <Route path="*" element={<Navigate to="/" />} /> */}

            <Route>{generateRoutes(categoriesData)}</Route>


          </Routes>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
